import { useLanguage } from '../context/LanguageContext';
import en from '../locales/en.json';
import ar from '../locales/ar.json';

const translations = {
  en,
  ar,
};

export function useTranslation() {
  const { language } = useLanguage();

  const t = (key, params = {}) => {
    if (!key || typeof key !== 'string') return '';
    const keys = key.split('.');
    let value = translations[language] || translations['en'];
    
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key; 
      }
    }

    if (typeof value === 'string' && params) {
      Object.keys(params).forEach((paramKey) => {
        value = value.replace(new RegExp(`{{${paramKey}}}`, 'g'), params[paramKey]);
      });
    }

    return value;
  };

  return { t, language };
}

export default useTranslation;
